module.exports = __webpack_public_path__ + "static/notification3-1150136333e05e78ee9b054f11e7f84d.png";